/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCostbasisV1RealizationEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_COSTBASIS_V1_REALIZATION_EVENT_ENTITY_NAME = 'ixc.costbasis.v1.RealizationEvent';
export const ixcCostbasisV1RealizationEventEntity = new schema.Entity<IxcCostbasisV1RealizationEvent>(IXC_COSTBASIS_V1_REALIZATION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcCostbasisV1RealizationEvent) => `${entity.metadata?.eventId}` });

